import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { ChangeWorkOrderTagComponent } from './ChangeWorkOrderTagComponent'
import { t } from '../../../intl/resources'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface MassiveWorkOrderTagModificationModalProps {
  workOrderIds: number[]
  massiveWorkOrderTagModificationModal: ModalReturnType<unknown>
  handleSnackbarNotification: (msg: string | undefined, status: boolean) => void
  handleRequestWorkOrders: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const MassiveWorkOrderTagModificationModal: React.FC<
  MassiveWorkOrderTagModificationModalProps
> = ({
  workOrderIds,
  massiveWorkOrderTagModificationModal,
  handleSnackbarNotification,
  handleRequestWorkOrders
}) => {
  const { isOpen, title, size, closeModal } =
    massiveWorkOrderTagModificationModal

  return (
    <Modal
      open={isOpen}
      title={title}
      maxWidth={size}
      onClose={closeModal}
      cancelButton={{
        title: t('EXIT'),
        action: () => {
          handleRequestWorkOrders()
          massiveWorkOrderTagModificationModal.closeModal()
        }
      }}
    >
      <ChangeWorkOrderTagComponent
        actualTag={''} // Empty, because its massive
        workOrderIds={workOrderIds}
        openSnackBar={handleSnackbarNotification}
      />
    </Modal>
  )
}
